import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'cargoType',
    'pinField',
    'pinFieldWrapper',
  ]

  togglePinField(event) {
    // Only need to consider container cargo type.
    if (!this.hasCargoTypeTarget || this.cargoTypeTarget.value != 'container') {
      this.clearAndHidePinField()
      return;
    }

    const shippingLineSelect = event?.target
    const selectedShippingLine = shippingLineSelect?.options[shippingLineSelect.selectedIndex]
    const shippingLineId = selectedShippingLine?.value

     if (!shippingLineId) {
      this.clearAndHidePinField()
      return
    }

    const form = this.element.closest('form')
    // Get verify pins array from form data attributes
    const verifyPins = form.dataset.verifyPins || '[]'

    // Only show pin when shipping line requires verification
    const showPin = verifyPins.includes(Number(shippingLineId))

    // Show/hide pin field
    if (showPin) {
      this.pinFieldTarget.value = ''
      this.pinFieldWrapperTarget.classList.remove('hidden')
    } else {
      this.clearAndHidePinField()
    }
  }

  clearAndHidePinField() {
    if (!this.hasPinFieldTarget) return;

    // Clear the pin field
    this.pinFieldTarget.value = ''
    // Hide the pin field
    this.pinFieldWrapperTarget.classList.add('hidden')
  }
}
